import {Storage} from "aws-amplify";
import {useState, useEffect} from 'react';

import './rdg-image.css';

export function ImageFormatter({ value, imgStyle, isGallery }) {

  const [image, setImage] = useState(null);

  //const imgPrefix = 'https://cardgallery-main162223-dev.s3.us-east-1.amazonaws.com/protected/us-east-1%3Aa02b7541-2bc2-47e4-b280-45cb86f09700/' //need to make this a var
  const imgPrefix = 'https://ik.imagekit.io/cardGallery/'
  const imgSuffix = '?tr=h-600'
  
 

  const getProfilePicture = (value) => {
    //console.log("IG " + isGallery)
    if (isGallery === 'true') {
      setImage(imgPrefix + value + imgSuffix)
    }
      else {
        Storage.get(value)
        .then(url => {
          var myRequest = new Request(url);
          fetch(myRequest).then(function(response) {
            if (response.status === 200) {
              setImage(url);
            }
          });
        })
        .catch(err => console.log(err));
      }
  }


  useEffect(() => {
    getProfilePicture(value)
    // eslint-disable-next-line
  }, [value]);

  
  if (imgStyle === "full" && value) {
    return (
      <div className="image">
        <img alt="card detail" src={image}/>
      </div>
    )
  }
  else if (value){
    return (
      <div className="rdg-image-cell-wrapper">
        <div className="rdg-image-cell" style={{ backgroundImage: `url(${image})` }} />
      </div>
    )
  }
  else {
    return <div ></div>
  }
}